import { Button, ButtonSize, ButtonVariant, Radio } from "shared/components";
import { Card } from "shared/components/Card";
import GoogleAnalyticsIcon from "shared/icons/brands/GoogleAnalytics-brand-icon.svg?react";
import { cx } from "shared/utils";
import {
  Integration,
  Step
} from "views/settings-integration/components/AddIntegrationModal/types";
import { useSettingsController } from "views/settings-integration/controller";

interface FirstStepProps {
  selectedIntegration: string;
  setSelectedIntegration: (name: string) => void;
  setCurrentStep: (step: Step) => void;
}

const integrations: Integration[] = [
  {
    id: "GA",
    name: "Google Analytics",
    icon: <GoogleAnalyticsIcon />
  }
];

export const FirstStep = ({
  selectedIntegration,
  setSelectedIntegration,
  setCurrentStep
}: FirstStepProps) => {
  const { currentSettings } = useSettingsController();

  return (
    <>
      {integrations.map((integration) => {
        const disabled =
          integration.id === "GA"
            ? Boolean(currentSettings.google.googleAnalyticsId)
            : false;

        return (
          <Card
            className={cx(
              "p-6 flex justify-between",
              disabled && "opacity-50 bg-alpha-40"
            )}
            key={integration.id}
            onClick={() => {
              if (!disabled) setSelectedIntegration(integration.name);
            }}
          >
            <div className="flex items-center gap-4">
              {integration.icon}
              <p className="font-bold text-base">{integration.name}</p>
            </div>
            <Radio
              className="mr-4 self-center cursor-pointer"
              id={integration.id}
              name={integration.name}
              // this onChange already handled above, added just to skip console error
              onChange={() => null}
              checked={selectedIntegration === integration.name}
            />
          </Card>
        );
      })}
      <Button
        variant={ButtonVariant.PRIMARY}
        size={ButtonSize.BASE}
        onClick={() => setCurrentStep(Step.SECOND)}
        disabled={!selectedIntegration}
        className="ml-auto mt-4"
      >
        Continue
      </Button>
    </>
  );
};
